export default "__VITE_ASSET__CUr9YT5S__"